export default __webpack_public_path__ + "media/color/xcp-78551307.svg";